import React from 'react';
import Row from '../Symbols/Row';
import Button from '../Symbols/Button';
import Result from './Result';
import Form from '../Symbols/Form';
import InputRadio from '../Symbols/InputRadio';
import InputSelect from '../Symbols/InputSelect';
import Input from '../Symbols/Input';
import Wrapper from '../Symbols/Wrapper';
import { genderOptions, GENDER_FEMALE } from '../common/GenderOptions';
import ChildrenVariant from '../retirement/Options';

const emptyFunc = () => {};

export default props => {
	const {
		validateHandler = emptyFunc,
		changeHandler = emptyFunc,
		changeTextHandler = emptyFunc,
		errors = {},
		state: { dateOfBorn, gender, children },
		result = null,
		onSubmit,
		reset,
	} = props;

	return (
		<Wrapper>
			<Form onSubmit={onSubmit} title="Kalkulačka - věk odchodu do důchodu">
				<Input
					label="Datum narození"
					onChange={changeTextHandler('dateOfBorn')}
					onBlur={validateHandler('dateOfBorn')}
					value={dateOfBorn}
					name="dateOfBorn"
					type="text"
					error={errors.dateOfBorn}
					passedProps={{ 'data-cy': 'dateOfBorn' }}
				/>

				<InputRadio
					label="Pohlaví"
					name="gender"
					value={gender}
					radio={genderOptions}
					onChange={changeHandler('gender')}
					onBlur={validateHandler('gender')}
					error={errors.gender}
					passedProps={{ 'data-cy': 'gender' }}
				/>

				{gender === GENDER_FEMALE && (
					<InputSelect
						label="Počet dětí"
						name="children"
						value={children}
						onChange={changeHandler('children')}
						onBlur={validateHandler('children')}
						passedProps={{ 'data-cy': 'children' }}
						select={ChildrenVariant}
						error={errors.children}
					/>
				)}

				<div css={Row}>
					<Button data-cy="submit">Výpočet</Button>
				</div>

				{result && <Result retirement={result} />}
				{result && (
					<div css={Row}>
						<Button onClick={reset} data-cy="reset">
							Nový výpočet
						</Button>
					</div>
				)}
			</Form>
		</Wrapper>
	);
};
